import makeQueryKey from "../../../utils/make-query-key";
var getWebShellProductQueryKey = function getWebShellProductQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    productCode = _ref.productCode,
    marketplace = _ref.marketplace,
    language = _ref.language;
  return makeQueryKey(['webShellClient', 'product', {
    productCode: productCode,
    marketplace: marketplace,
    language: language
  }]);
};
export default getWebShellProductQueryKey;